import React, { Component } from 'react';
import ComboBox from '../combo-box'
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import CardContent from 'material-ui/Card/CardContent';
import Card from 'material-ui/Card';
import Button from 'material-ui/Button';
import CardActions from 'material-ui/Card/CardActions'
import CloseIcon from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton/IconButton';
import Typography from 'material-ui/Typography';
import green from 'material-ui/colors/green';
import Portal from 'material-ui/Portal'
import SaveIcon from 'material-ui-icons/Save';
import { CircularProgress } from 'material-ui/Progress';
import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';
import Switch from 'material-ui/Switch';
import {FormControlLabel} from 'material-ui/Form';

import { ajaxPost } from '../ajax';


const styles = theme => ({
    title:
    {
        color:"white",
        flex:1,
        marginTop:20,
    },
    card:
        {
            margin: 10
        },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 15,
        width: 200,
    },
    menu: {
        width: 200,
    },
    button: {
        '&:hover': {
          backgroundColor: green[700],
        },
      },
      fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -25,
        marginLeft: -25,
          },
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
      dialog:
      {
          margin:"20px 20px 40px 20px"
      },
      
});

function handleSelectChange(selectedOption) {
    this.setState({ department: selectedOption });
}


class DeviceForm extends Component {
    state =
        {
            device: null,
            saving:false,
            dialog:false,
            dialogContent:null,
            dialogTitle:'',
        }

    constructor(props) {
        super(props);
        this.state.device = props.device;

        if (props.getRef != null)
            props.getRef(this);
    }



    handleChange = name => event => {
        var current = this.state.device;
        current[name] = event.target.value;
        this.setState({ device: current });
    };

    onCloseDialog = () =>
    {
        this.setState({dialog:false});
        this.props.onUpdateComplete(this.state.device);
    }


    onSave = () => {
        var dev = this.state.device;
        this.setState({saving:true});
        var {classes} = this.props;

        var data =
            {
                DeviceID: dev.DeviceID,
                DeviceName: dev.DeviceName,
                SerialNumber: dev.SerialNumber,
                IPAddress: dev.IPAddress,
                Status: dev.Status,
            };

        ajaxPost({
            url: '/DeviceAPI/' + (this.state.device.DeviceID === -1 ? 'SaveNew' : 'SaveUpdate'),
            data: data,
            onError: ()=>{},
            onSuccess: data => {
                this.setState({dialogTitle:"Save"})
                this.setState({dialogContent:(
                    <div className={classes.dialog}>
                    <Typography>Device information has been updated successfully</Typography>
                    </div>
                 )});
                this.setState({dialog:true});
            },
            finally: ()=>
            {
                this.setState({saving:false});
                
            }
        }
        )
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ device: nextProps.device });
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
            <Portal container={this.props.toolbar}>
                <Typography type="title" color="inherit" className={classes.title}>
                {this.state.device.DeviceID == -1 ? 'Add new device' : this.state.device.DeviceName}
                </Typography>
                <div className={classes.wrapper}>
                    <IconButton style={{ "color": "#606060" }} disabled={this.state.saving} color="inherit" className={classes.button} onClick={this.onSave}>
                        <SaveIcon />
                    </IconButton>
                    {this.state.saving && <CircularProgress size={50} className={classes.fabProgress} />}
                </div>
                <div className={classes.wrapper}>
                    <IconButton style={{ "color": "#606060" }} disabled={this.state.saving}  className={classes.button} color="inherit" 
                    onClick={this.props.onCloseForm}>
                        <CloseIcon />
                    </IconButton>
                </div>
            </Portal>


            <Card>
                <CardContent style={{ "background": "transparent" }}>
                    {
                        [
                            [
                                { cap: "DeviceName", prop: "DeviceName" },
                                { cap: "SerialNumber", prop: "SerialNumber" },
                                { cap: "IPAddress", prop: "IPAddress" },
                            ],
                        ]
                            .map(grp =>
                                (
                                    <div className={classes.container}>
                                        {
                                            grp.map(item =>
                                                (
                                                    <TextField className={classes.textField}
                                                        value={this.state.device[item.prop]}
                                                        label={item.cap}
                                                        onChange={this.handleChange(item.prop).bind(this)} />
                                                ))
                                        }
                                    </div>
                                )
                            )
                    }
                    <div className={classes.container}>
                    <FormControlLabel
                        control={
                            <Switch
                                onChange={(event,checked)=>
                                {
                                    var current = this.state.device;
                                    current.Status = checked ? 'ACTIVE' : 'DISABLED';
                                    this.setState({ device: current });
                                }
                                }
                                checked={this.state.device.Status != 'DISABLED'}
                            />
                        }
                        label="Device is Active"
                        />
                        </div>



                </CardContent>
            </Card>
            <Dialog onClose={this.onCloseDialog.bind(this)} open={this.state.dialog}>
                <DialogTitle>{this.state.dialogTitle}</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    {this.state.dialogContent}
                </DialogContentText>
            </DialogContent>
                <DialogActions>
            <div className={classes.wrapper}>
                <Button 
                color="primary" className={classes.button} onClick={this.onCloseDialog.bind(this)}>
                OK
                </Button>
            </div>
            </DialogActions>
            </Dialog>

            </div>
        )
    }
}
export default withStyles(styles)(DeviceForm);



// WEBPACK FOOTER //
// ./src/admin/DeviceForm.js